import * as React from "react";
import { RouteComponentProps } from "react-router";
import { withRouter } from "react-router-dom";
import {
  Input,
  Dialog,
  Checkbox,
  Button,
  WithDialog,
} from "@abb/abb-common-ux-react";

import SubmitHeader from "../shared/SubmitHeader";
import history from "../../utilities/History";

import navigationHeaderActions from "../../flux/actions/NavigationHeaderActions";
import * as CONSTANTS from "../../utilities/Constants";
import * as ICONCONSTANTS from "../../utilities/IconConstants";

import submitHeaderActions from "../../flux/actions/SubmitHeaderActions";

import stationActions from "../../flux/actions/StationActions";
import IColumnHeaderData from "../../models/shared/ColumnHeaderData";
import IStationFormData from "../../models/station/StationFormData";
import IFormComponent from "../../models/shared/FormComponent";
import { IInstrumentViewData } from "../../models/instrument/InstrumentViewData";
import instrumentListStore from "../../flux/stores/instrument/ListStore";
import instrumentActions from "../../flux/actions/InstrumentActions";
import triggerNotifications from "../../utilities/TriggerNotifications";
import stationFormStore from "../../flux/stores/station/FormStore";
import AbbTableComponent from "../shared/AbbTableComponent";
import { Translation } from "react-i18next";
import { Icon, Tooltip, WithTooltip } from "@abb/abb-common-ux-react";
import { ABB_CLOSE } from "../../utilities/IconConstants";
type PropsType = RouteComponentProps & {};

interface IState {
  stationFormData: IStationFormData;
  oldData: IStationFormData;
  showModalPopup: boolean;
  instruments: IInstrumentViewData[];
  selectedInstruments: IInstrumentViewData[];
  dummySelectedInstruments: IInstrumentViewData[];
  status: boolean;
  formLoading: boolean;
  nameError: boolean;
}

class Form
  extends React.Component<PropsType, IState>
  implements IFormComponent
{
  _mount = false;
  _isReload: boolean;
  _isEdit = false;
  _columns: IColumnHeaderData[];
  _properties: [];
  private _messages: string[];
  _id: string;
  _isAssociatedInstrument: boolean = false;

  constructor(props: PropsType) {
    super(props);
    const pushStateData = this.props.location.state as IStationFormData;
    this.state = {
      stationFormData: pushStateData,
      showModalPopup: false,
      instruments: [],
      selectedInstruments: pushStateData?.instruments,
      dummySelectedInstruments: pushStateData?.instruments,
      status: true,
      formLoading: false,
      oldData: { ...pushStateData },
      nameError: false,
    };

    this._mount = false;
    this._messages = [];
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidUpdate() {
    if (
      JSON.stringify(this.state.oldData) !==
      JSON.stringify(this.state.stationFormData)
    ) {
      navigationHeaderActions
        .updateHeader({
          name: CONSTANTS.MODULE_STATION,
          action: this.state.stationFormData?.isEditMode
            ? CONSTANTS.EDIT
            : CONSTANTS.CREATE,
          icon: this.state.stationFormData?.isEditMode
            ? ICONCONSTANTS.ABB_EDIT
            : ICONCONSTANTS.ABB_PLUS,
          goBackUrl: CONSTANTS.STATION_INDEX_URL,
          isGoBackWithData: false,
          goBackData: {},
          isDataChanged: true,
        })
        .then();
    }
  }

  componentDidMount() {
    this._mount = true;

    stationActions
      .getAll(
        1,
        CONSTANTS.PAGE_SIZE_ALL,
        CONSTANTS.SORT_CREATEDON,
        CONSTANTS.SORT_ORDER,
        ""
      )
      .then();

    if (this.state.stationFormData?.isEditMode) {
      submitHeaderActions
        .update({
          moduleName: CONSTANTS.MODULE_STATION,
          isSubmitDisabled: false,
        })
        .then();
    }

    navigationHeaderActions
      .updateHeader({
        name: CONSTANTS.MODULE_STATION,
        action: this.state.stationFormData?.isEditMode
          ? CONSTANTS.EDIT
          : CONSTANTS.CREATE,
        icon: this.state.stationFormData?.isEditMode
          ? ICONCONSTANTS.ABB_EDIT
          : ICONCONSTANTS.ABB_PLUS,
        goBackUrl: CONSTANTS.STATION_INDEX_URL,
        isGoBackWithData: false,
        goBackData: {},
        isDataChanged: false,
      })
      .then();

    instrumentListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        for (let i = 0; i < state.instrumentDataList.result.length; i++) {
          if (!state.instrumentDataList.result[i].isAssociated) {
            this._isAssociatedInstrument = true;
            break;
          }
        }
        this.setState({ instruments: state.instrumentDataList.result });
      }
    });

    stationFormStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._isReload = false;
        this._id = state.stationId;
        this._messages = state.message;
      }
    });
  }

  private setName = (value: string) => {
    var rgFile = CONSTANTS.COMMONREGEXP;
    if (
      value.trim() &&
      !rgFile.test(value)
    ) {
      const stationFormData = this.state.stationFormData;
      stationFormData.name =
        value.length > 1 ? value : value.replace(/\s/g, "");
      this.setState({ stationFormData, nameError: false }, this.validate);
    } else {
      const stationFormData = this.state.stationFormData;
      stationFormData.name =
        value.length > 1 ? value : value.replace(/\s/g, "");
      this.setState({ stationFormData, nameError: true }, this.validate);
    }
  };

  private setDescription = (value: string) => {
    this.setState({
      stationFormData: {
        ...this.state.stationFormData,
        description: value,
      },
    });
  };

  validate(): void {
    if (
      !this.state.nameError &&
      this.state.stationFormData.name &&
      this.state.stationFormData.name.trim() &&
      this.state.stationFormData.instruments.some((i) => i.id)
    ) {
      submitHeaderActions
        .update({
          moduleName: CONSTANTS.MODULE_STATION,
          isSubmitDisabled: false,
        })
        .then();
    } else {
      submitHeaderActions
        .update({
          moduleName: CONSTANTS.MODULE_STATION,
          isSubmitDisabled: true,
        })
        .then();
    }
  }

  public deleteInstrument = (data: any, rowIndex: number) => {
    const filterData = this.state.stationFormData.instruments.filter(
      (item) => item.id !== data.id
    );
    let selectedInstruments = this.state.selectedInstruments;
    if (selectedInstruments.find((el: any) => el.id === data.id)) {
      selectedInstruments = selectedInstruments.filter(
        (elements: any) => elements.id !== data.id
      );
    }
    this.setState(
      {
        stationFormData: {
          ...this.state.stationFormData,
          instruments: filterData,
        },
        selectedInstruments,
      },
      this.validate
    );
  };

  public onSaveClick = () => {
    const tempName = this.state.stationFormData.name
      .replace(/ +(?= )/g, "")
      .trim();
    this.setState(
      (prevState) => ({
        formLoading: true,
        stationFormData: {
          // object that we want to update
          ...prevState.stationFormData, // keep all other key-value pairs
          name: tempName, // update the value of specific key
        },
      }),
      () => {
        stationActions
          .put(this.state.stationFormData)
          .then(() => {
            this.setState(
              {
                formLoading: false,
              },
              () => {
                triggerNotifications.success(this._messages);
                setTimeout(() => {
                  history.push("/ManageInstrument/InstrumentStation/", {
                    isReloadFirst: this._isReload,
                    id: this._id,
                    message: this._messages,
                  });
                }, CONSTANTS.NOTIFICATION_TIMEOUT);
              }
            );
          })
          .catch((error) => {
            this.setState(
              {
                formLoading: true,
              },
              () =>
                triggerNotifications.errors(error.message, error.data).then()
            );
          });
      }
    );
  };

  private associationAction = () => {
    instrumentActions
      .getAll(
        false,
        1,
        CONSTANTS.PAGE_SIZE,
        CONSTANTS.SORT_CREATEDON,
        CONSTANTS.SORT_ORDER,
        ""
      )
      .then();
    this.setState({
      showModalPopup: true,
      selectedInstruments: this.state.stationFormData.instruments,
    });
  };

  public onCreateClick = () => {
    const tempName = this.state.stationFormData.name
      .replace(/ +(?= )/g, "")
      .trim();
    this.setState(
      (prevState) => ({
        formLoading: true,
        stationFormData: {
          // object that we want to update
          ...prevState.stationFormData, // keep all other key-value pairs
          name: tempName, // update the value of specific key
        },
      }),
      () => {
        stationActions
          .post(this.state.stationFormData)
          .then(() => {
            this.setState(
              {
                formLoading: false,
              },
              () => {
                triggerNotifications.success(this._messages);
                setTimeout(() => {
                  history.push("/ManageInstrument/InstrumentStation/", {
                    isReloadFirst: this._isReload,
                    id: this._id,
                    message: this._messages,
                  });
                }, CONSTANTS.NOTIFICATION_TIMEOUT);
              }
            );
          })
          .catch((error) => {
            this.setState(
              {
                formLoading: false,
              },
              () =>
                triggerNotifications.errors(error.message, error.data).then()
            );
          });
      }
    );
  };

  private onChange = (data: any) => {
    if (this.state.selectedInstruments.some((d) => d.id === data.id)) {
      let selectedInstruments = this.state.selectedInstruments;
      if (selectedInstruments.find((el: any) => el.id === data.id)) {
        selectedInstruments = selectedInstruments.filter(
          (elements: any) => elements.id !== data.id
        );
      }

      this.setState({
        selectedInstruments,
      });
    } else {
      this.setState({
        selectedInstruments: [...this.state.selectedInstruments, data],
      });
    }
  };

  private onOkClick = () => {
    this.setState(
      {
        showModalPopup: false,
        stationFormData: {
          ...this.state.stationFormData,
          instruments: this.state.selectedInstruments,
        },
      },
      this.validate
    );
  };

  onCancelClick = () => {
    history.push(CONSTANTS.STATION_INDEX_URL, {
      isReloadFirst: this._isReload,
      id: this._id,
    });
  };

  public render() {
    return (
      <Translation>
        {(t) => (
          <div className="page-scroll">
            <div className="layout-container">
              <SubmitHeader
                name={CONSTANTS.MODULE_STATION}
                link="ManageInstrument/InstrumentStation/"
                isEdit={this.state.stationFormData?.isEditMode}
                onSaveClick={this.onSaveClick}
                onCreateClick={this.onCreateClick}
                onCancelClick={this.onCancelClick}
                isLoading={this.state.formLoading}
              />
              <div className="mt-3">
                <div className="col-md-12 no-padding">
                  <div className="box">
                    <div className="box-circle">
                      <p className="box-circle-text"> 1 </p>
                    </div>
                    <div className="ml-4">
                      <p className="sidebar-main-title font-weight-bold ml-2">
                        {t(CONSTANTS.MODULE_STATION) +
                          " " +
                          t(CONSTANTS.TITLE_TESTOVERVIEW_DETAILS)}
                      </p>
                    </div>
                    <hr className="hr-line" />

                    <div className="row mt-3">
                      <div className="col-sm col-md-6">
                        <Input
                          inputAttributes={{ autoFocus: "true" }}
                          dataType="text"
                          placeholder={t(CONSTANTS.LABLE_NAME)}
                          label={t(CONSTANTS.LABLE_NAME)}
                          required={true}
                          className={
                            this.state.nameError
                              ? "error-code mt-2 w-50"
                              : "mt-2 w-50"
                          }
                          value={this.state.stationFormData?.name}
                          onValueChange={this.setName}
                          maxLength={250}
                          showValidationBarWhenInvalid={
                            this.state.nameError ? true : false
                          }
                          description={
                            this.state.nameError
                              ? this.state.stationFormData.name.length
                                ? t(CONSTANTS.NAME_VALIDATION_ERROR)
                                : t(CONSTANTS.FIELD_EMPTY_ERROR)
                              : ""
                          }
                        />
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-sm col-md-6">
                        <Input
                          dataType="textarea"
                          label={t(CONSTANTS.LABEL_DESCRIPTION)}
                          placeholder={t(CONSTANTS.LABEL_DESCRIPTION)}
                          value={this.state.stationFormData?.description}
                          onValueChange={this.setDescription}
                          inputAttributes={{ rows: "4" }}
                          className="mt-2 h-25"
                          resizable={false}
                          maxLength={200}
                        />
                      </div>
                    </div>
                    <div className="p-3">
                      {200 - this.state.stationFormData?.description?.length}{" "}
                      {t("character left out of 200 character")}
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-2 mb-4">
                <AbbTableComponent
                authKey={CONSTANTS.AUTHKEY_INSTRUMENT_STATION}
                  columns={[
                    {
                      dataField: "name",
                      text: t(CONSTANTS.MODULE_INSTRUMENT),
                      headerStyle: (colum, colIndex) => {
                        return { width: "15%", textAlign: "left" };
                      },
                    },

                    {
                      dataField: "type.name",
                      text: t(CONSTANTS.MODULE_INSTRUMENTTYPE),
                      headerStyle: (colum, colIndex) => {
                        return { width: "15%", textAlign: "left" };
                      },
                    },
                    {
                      dataField: "directions",
                      text: t(CONSTANTS.LABEL_DIRECTIONS),
                      headerStyle: (colum, colIndex) => {
                        return { width: "15%", textAlign: "left" };
                      },
                    },
                    {
                      dataField: "state",
                      text: t(CONSTANTS.LABEL_STATE),
                      headerStyle: (colum, colIndex) => {
                        return { width: "35%", textAlign: "left" };
                      },
                    },
                    {
                      dataField: "delete",
                      text: "",
                    },
                  ]}
                  list={this.state.stationFormData?.instruments}
                  select={false}
                  isFixedColumn={false}
                  isEditable={false}
                  delete={false}
                  associationText="Associate Instruments"
                  associationAction={this.associationAction}
                  cellDelete={this.deleteInstrument}
                  isAssociation={true}
                  isRowClass={"station-normal-row"}
                  isTitle={
                    <div className="float-left">
                      <div className="box-circle">
                        <p className="box-circle-text"> 2 </p>
                      </div>
                      <div className="ml-4">
                        <p className="sidebar-main-title font-weight-bold ml-2">
                          {t(CONSTANTS.ASSOCIATE_INSTRUMENT)}
                        </p>
                      </div>
                    </div>
                  }
                />
              </div>

              <Dialog
                isOpen={this.state.showModalPopup}
                // tslint:disable-next-line: jsx-no-lambda
                onClose={() => this.setState({ showModalPopup: false })}
                showCloseButton={true}
                closeOnEscape={false}
                closeOnLostFocus={false}
                dimBackground={true}
                title={
                  this.state.selectedInstruments?.length
                    ? t(CONSTANTS.ASSOCIATE_INSTRUMENT) +
                      " " +
                      `(${this.state.selectedInstruments.length})`
                    : t(CONSTANTS.ASSOCIATE_INSTRUMENT)
                }
                standardButtonsOnTop={
                  this.state.selectedInstruments?.length ||
                  this.state.stationFormData?.instruments?.length
                    ? [
                        {
                          text: t(CONSTANTS.BUTTON_CANCEL),
                          type: "discreet-blue",
                          handler: (dlg) => dlg.close(),
                        },
                        {
                          text: t(CONSTANTS.BUTTON_OK),
                          type: "primary-blue",
                          handler: this.onOkClick,
                        },
                      ]
                    : []
                }
                style={{ position: "relative" }}
              >
                {(!this.state.stationFormData?.isEditMode &&
                  !this._isAssociatedInstrument) ||
                (this.state.selectedInstruments?.length === 0 &&
                  this.state.stationFormData.instruments.length === 0) ? (
                  <span
                    className="cross-hover"
                    onClick={this.onOkClick}
                    style={{
                      position: "absolute",
                      left: "86%",
                      top: "10%",
                      height: "30px",
                      width: "30px",
                    }}
                  >
                    <Icon
                      name={ABB_CLOSE}
                      sizeClass="medium"
                      className="icon-fullscreen cursor"
                      style={{
                        marginLeft: "3px",
                        marginTop: "3px",
                      }}
                    />
                  </span>
                ) : (
                  <></>
                )}
                <div className="station-form-scroll">
                  {}
                  {}
                  {(this.state.stationFormData?.isEditMode
                    ? this.state.instruments.filter(
                        (i) =>
                          i.isAssociated === false ||
                          (i.isAssociated &&
                            this.state.dummySelectedInstruments.find(
                              (item) => item.id === i.id
                            ))
                      )
                    : this.state.instruments.filter(
                        (i) => i.isAssociated === false
                      )
                  ).map((i) => (
                    <Checkbox
                      key={Math.random()}
                      label={i.name}
                      value={this.state.selectedInstruments.some(
                        (d) => d.id === i.id
                      )}
                      onChange={this.onChange}
                      sizeClass="small"
                      data={i}
                    />
                  ))}
                </div>
                {this.state.stationFormData?.isEditMode ||
                this._isAssociatedInstrument ? (
                  <div> </div>
                ) : (
                  <div className="flex-center">
                    <b>{t("No instrument is available to map")}</b>
                  </div>
                )}
              </Dialog>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

export default withRouter(Form);
